
import { isNull } from "util";
import Vue from "vue";
import { Prop, Component, Watch, Ref } from "vue-property-decorator";
import { clickLocationModel } from "@/models/ui/clickLocation";

@Component
export default class RightClickMenu extends Vue {
  localClickLocation: clickLocationModel = null;

  @Ref() readonly dropdownMenu!: HTMLElement;

  @Prop({ default: 0 })
  selectedLength: number;

  @Prop({ default: [] })
  menuItems: Array<any>;

  @Prop({ default: Object })
  clickLocation: null;

  @Prop({ default: 297 })
  defaultMenuHeight: number;

  @Prop({ default: 160 })
  defaultMenuWidth: number;

  get isDisabled() {
    return false;
  }
  set isDisabled(menuItem: any) {
    this.isDisabled = menuItem.onlySingleSelect ? true : false;
  }

  get localStyle() {
    if (isNull(this.localClickLocation) || this.localClickLocation === { x: 0, y: 0 }) {
      return "";
    } else {
      let width =
        window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      let height =
        window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      let top = this.localClickLocation.y;
      let minHeight = this.dropdownMenu.clientHeight || this.defaultMenuHeight;
      let minWidth = this.dropdownMenu.clientWidth || this.defaultMenuWidth;

      if (height - top < minHeight) {
        top = top - minHeight + 20;
      }
      top = top - 10;
      let left = this.localClickLocation.x;
      if (width - left < minWidth) {
        left = left - minWidth + 20;
      }
      left = left - 10;
      return `display:block;position:fixed;top:${top}px;left:${left}px;z-index:9999;`;
    }
  }

  @Watch("clickLocation")
  clicked(newValue) {
    return (this.localClickLocation = JSON.parse(JSON.stringify(newValue)));
  }

  itemClicked(item) {
    this.$emit("click", item);
  }

  hide() {
    this.localClickLocation = null;
  }
}
